<div class="creations-container">
  @if (accountService.account.value) {
  <!-- Logged in user - keep it simple -->
  <div class="logged-in-section">



    <h1>Your Scripts</h1>

    <app-script-sunset-banner></app-script-sunset-banner>


    <div class="scripts-list">

      <mat-card>
        <mat-card-header>
          <mat-card-title>Tutorial</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>
            Learn how to write scripts for Audience Anarchy.
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button [routerLink]="['/scripts/tutorial']">Learn More</button>
        </mat-card-actions>
      </mat-card>

      <mat-card class="new-script-card" [routerLink]="isCreationAllowed ? ['/scripts/submit'] : null" [style.opacity]="isCreationAllowed ? 1 : 0.6" [style.cursor]="isCreationAllowed ? 'pointer' : 'not-allowed'">
        <mat-card-header>
          <mat-card-title>New Script</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ isCreationAllowed ? 'Start writing a new script' : 'New script creations are currently disabled.' }}</p>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-button [routerLink]="isCreationAllowed ? ['/scripts/submit'] : null" [disabled]="!isCreationAllowed">Create New Script</button>
        </mat-card-actions>
      </mat-card>

      <h2>Your submissions </h2>

      @for (script of scripts; track script.id) {
        <app-script-card 
        tabindex="0" 
        [routerLink]="isScriptAccessible(script) ? ['/scripts/submit', script.id] : null" 
        [style.opacity]="isScriptAccessible(script) ? 1 : 0.6"
        [style.cursor]="isScriptAccessible(script) ? 'pointer' : 'not-allowed'"
        [script]="script">
        </app-script-card>
      } @empty {
      <h2>No scripts submitted yet. Get started by creating a new script using the button above.</h2>
      }

    </div>
  </div>
  } @else {
  <!-- Not logged in - use Patreon-style design -->
  <div class="guest-section">
    <div class="hero-section">
      <h1>Write Scripts</h1>
      <p class="hero-subtitle">Join the creative community and create your own Audience Anarchy scripts!</p>
    </div>

    <div class="guest-options">
      <mat-card class="option-card">
        <div class="option-icon">
          <mat-icon>edit_note</mat-icon>
        </div>
        <mat-card-content>
          <h3>Log in to start writing</h3>
          <p>To get started, log in or create an account using Discord. This allows you to easily manage your scripts, track your submissions, and build your author profile.</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-flat-button  [routerLink]="['/login']">Login with Discord</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  }
</div>